import styled from "styled-components";

export const Round = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: red;
  margin-left: 5px;
  margin-top: 2px;
`;
export const Disabled = styled.span`
  color: red;
`;
export const Absence = styled.div`
  width: -webkit-fill-available;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 0;
  justify-content: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  color: gray;
  font-size: 12px;
  overflow: hidden;
  flex-wrap: wrap;
  background-image: linear-gradient(315deg, #cefad0 25%, transparent 25%, transparent 50%, #cefad0 50%, #cefad0 75%, transparent 75%, transparent), linear-gradient(-45deg, #cefad0 25%, transparent 25%, transparent 50%, #cefad0 50%, #cefad0 75%, transparent 75%, transparent);
  background-size: 10px 10px;
  &.weekend {
    background-image: linear-gradient(315deg, #ebebeb 25%, transparent 25%, transparent 50%, #ebebeb 50%, #ebebeb 75%, transparent 75%, transparent), linear-gradient(-45deg, #ebebeb 25%, transparent 25%, transparent 50%, #ebebeb 50%, #ebebeb 75%, transparent 75%, transparent);
    background-size: 10px 10px;
  }
  span {
    flex-wrap: wrap;
    text-wrap: wrap;
  }
`;
// export const Schedule = styled.button`
//   white-space: nowrap;
//   position: relative;
//   background: white;
//   border: 1px solid ${(props) => props.color};
//   padding: 0px;
//   padding-left: 15px;
//   padding-right: 10px;
//   border-radius: 8px;
//   font-size: 12px;
//   display: flex;
//   flex-direction: column;
//   text-align: left;
//   justify-content: center;
//   // min-width: 75px;
//   min-height: 30px;

//   .leave {
//     font-size: 12px !important;
//   }
//   &.absence {
//     width: -webkit-fill-available;
//   }

//   span:first-child {
//     margin-top: 3px;
//     margin-bottom: 3px;
//     font-weight: 600;
//     overflow: hidden;
//     max-width: 100%;
//   }
//   &:hover .action {
//     display: flex;
//   }
//   span:first-child > span {
//     color: white;
//     background-color: red;
//     padding: 2px 5px;
//     border-radius: 12px;
//     margin-left: 5px;
//     position: absolute;
//     right: 3px;
//     left: auto;
//     width: auto;
//     top: 0px;
//   }
//   span:last-child {
//     font-size: 10px;
//     margin-bottom: 3px;
//   }
//   &.roster span:last-child {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     column-gap: 5px;
//   }
//   &::after {
//     background-color: ${(props) => props.color};
//     color: ${(props) => props.color};
//     content: "";
//     border-radius: 8px 0px 0px 8px;
//     width: 10px;
//     position: absolute;
//     height: 100%;
//     left: 0;
//     margin: 0px;
//   }
//   &.expired,
//   &.Pending {
//     background-color: #ffffff;
//     color: #7d7d7d;
//     > span {
//       opacity: 0.7;
//     }
//     .action {
//       opacity: 1;
//     }
//   }
//   &.expired::after,
//   &.Pending::after {
//     opacity: 0.3;
//   }
//   &.active {
//     background-color: grey;
//     color: white;
//   }
//   &:hover {
//     background-color: black;
//     color: white;
//   }
//   &.selected {
//     background-color: red !important;
//     color: white !important;
//   }
//   &.marked {
//     background-color: grey !important;
//     color: white !important;
//   }
//   &.day {
//     width: -webkit-fill-available;
//     width: auto;
//   }
//   &.day.required {
//     width: -webkit-fill-available;
//     width: inherit;
//   }
// `;
// export const SchedulesBox = styled.span`
//   display: grid;
//   grid-row-gap: 3px;
//   position: relative;
//   width: max-content;
//   width: -webkit-fill-available;
//   margin: 2px;

//   &.wrap {
//     display: flex;
//     column-gap: 5px;
//     flex-flow: wrap;
//   }
//   &.day {
//     width: auto;
//     min-height: 40px;
//     // overflow: hidden;
//     // margin: 2px;
//   }
//   &.week {
//     width: auto;
//     overflow: hidden;
//     margin: 2px;
//   }
//   &.month {
//     width: auto;
//     overflow: hidden;
//     margin: 2px;
//   }
// `;

export const HoverActions = styled.span`
  position: absolute;
  left: 0;
  display: none;
  right: 0;
  top: 0;
  bottom: -3px;
  border-radius: 7px;
  background-color: ${(props) => props.color};
  color: white;
  justify-content: center;
  align-items: center;
  column-gap: 5px;
  z-index: 1;
  button {
    background-color: white;
    color: ${(props) => props.color};
    border-radius: 5px;
    border: 0;
    cursor: pointer;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }
`;

export const Collapse = styled.span`
  margin-right: 5px;
  padding: 5px;
  cursor: pointer;
  svg {
    transition: 0.2s ease-out;
    transform: rotate(270deg);
  }
  &.true svg {
    transform: rotate(0deg);
  }
`;

// Style for the button container div
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; /* Adjust margin as needed */
  button {
    padding: 10px 10px;
    background-color: ${(props) => props.theme.themeBackground}; /* Button background color */
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    -webkit-transition: background-color 0.2s;
    transition: background-color 0.2s;
    align-items: center;
    display: flex;

    &:hover {
      transform: scale(1.05);
      transition: all 0.2s;
      background-color: ${(props) => props.theme.themeBackground}; /* Button background color on hover */
    }
  }
  button:first-child {
    svg {
      margin-right: 5px;
    }
  }
  button:last-child {
    svg {
      margin-right: 5px;
    }
  }
`;

export const AddButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px; /* Adjust margin as needed */
  button {
    padding: 10px 10px;
    background-color: ${(props) => props.theme.themeBackground}; /* Button background color */
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    -webkit-transition: background-color 0.2s;
    transition: background-color 0.2s;
    align-items: center;
    display: flex;

    &:hover {
      transform: scale(1.05);
      transition: all 0.2s;
      background-color: ${(props) => props.theme.themeBackground}; /* Button background color on hover */
    }
  }
  button:first-child {
    svg {
      margin-right: 5px;
    }
  }
  button:last-child {
    svg {
      margin-right: 5px;
    }
  }
`;

// Define the style for the table
export const CalendarTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  height: -webkit-fill-available;
  tr {
    background-color: white;
  }

  td {
    padding: 8px;
    text-align: center;
    border: 1px solid #ccc;
    background-color: white;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
    user-select: none;
    font-weight: bold;
    color: #5b5b5b;
    position: relative;
    min-height: 200px;
    height: 70px;
    min-width: 100px;
    width: 14.29%;
    &:hover {
      /* background-color: ${(props) => props.theme.themeBackground};
      color: #fff; */
      border: 1px solid;
    }
  }
  td.disabled {
    background-color: #f4f4f4;
  }
  td .dayNumber {
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 10;
    border-radius: 0;
    border-bottom-left-radius: 50%;
    right: 5px;
    top: 5px;
    border-radius: 50%;
    background-color: #3FC4FD;
    color: white;
    width: 25px;
    height: 25px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  tr .sun {
    color: red;
  }
  tbody {
    // Styles for the table body
  }

  th {
    padding: 8px;
    text-align: center;
    background-color: #eef4fe;
    border: 1px solid #ccc;
    font-weight: bold;

  }

  thead tr:first-child th {
    font-size: 20px;
  }

  @media(max-width: 768px){
    td {
      min-height: 40px;
      min-width: 40px;
      padding: 0px;
    }
    td .dayNumber {
      top: 0px;
      left: 45%;
      right: auto;
      width: auto !important;
      height: auto !important;
      font-size: 10px;
      background-color: #ffffff;
      color: #000000;
      
    }
    tr .sun {
      color: red;
    }
    th {
      border: none;
    }
  }

`;
export const SchedulesBox = styled.span`
  display: flex;
  grid-row-gap: 3px;
  position: relative;
  height: auto;
  align-items: flex-start;
  justify-content:baseline;
  margin-bottom: 0;
  margin-top: auto;
  height: 100%;
  flex-direction:column;
  &.wrap {
    display: flex;
    column-gap: 5px;
    flex-flow: wrap;
  }
  // &.availability > button:first-of-type {
  //   margin-top: 15px;
  // }

  .available-from {
    color: #000000;
    display: block;
    font-size: 12px;
  }
  
  @media(max-width: 768px){
    margin-top: 0;
    &.availability > button:first-of-type {
      margin-top: 0px;
    }
    .available-from {
      font-size: 10px;
    }
  }
`;
export const Schedule = styled.button`
  white-space: nowrap;
  position: relative;
  background: white;
  border: 1px solid ${(props) => props.color};
  padding: 0px;
  padding-left: 15px;
  padding-right: 10px;
  border-radius: 8px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: auto;
  margin-right: 23px;
  width: -webkit-fill-available;
  z-index: 1;
  span:first-child {
    margin-top: 3px;
    margin-bottom: 3px;
    font-weight: 600;
  }
  &:hover .action {
    display: flex;
  }
  span:first-child > span {
    color: white;
    background-color: red;
    padding: 2px 5px;
    border-radius: 12px;
  }
  span:last-child {
    font-size: 10px;
    margin-bottom: 3px;
  }
  &.roster span:last-child {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 5px;
  }
  &::after {
    background-color: ${(props) => props.color};
    color: ${(props) => props.color};
    content: "";
    border-radius: 8px 0px 0px 8px;
    width: 10px;
    position: absolute;
    height: 100%;
    left: 0;
    margin: 0px;
  }
  &.expired {
    opacity: 0.4;
  }
  &.active {
    background-color: grey;
    color: white;
  }
  &:hover {
    background-color: black;
    color: white;
  }
  &.selected {
    background-color: red !important;
    color: white !important;
  }
  &.marked {
    background-color: grey !important;
    color: white !important;
  }

  @media(max-width: 768px) {
    margin-right: 0px;
    margin-top: 0px;
    padding-bottom: 12px;
    padding-left: 5px;
    padding-right: 5px;
    width: auto;

    span:first-child {
      margin-top: 1px;
      margin-bottom: 1px;
      font-weight: 600;
      font-size: 12px;
    }

    span:last-child {
      margin-top: 1px;
      margin-bottom: 1px;
      font-weight: 600;
      font-size: 12px;
    }

    &::after {
      width: 100%;
      bottom: 0;
      height: 10px;
      border-radius: 0px 0px 8px 8px;
    }

  }
`;
export const AvailabilitiesSchedule = styled.button`
  
  padding: 1px 0 1px 5px;
  margin-top: -5px;
  margin-right: 23px;
  text-align: center;
  border-radius: 8px;
  position: absolute;
  border: none;
  top: 0;
  left:0;
  right:0;
  z-index:11;
  @media(max-width: 768px) {
    margin-right: 0px;
    width: 100%;
    position: static;
    padding: 1px;
  }
`;

